// @ts-ignore
import * as Klaro from 'klaro';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ParallaxProvider } from 'react-scroll-parallax';

import klaroConfig from 'components/config.klaro';
import Menu from 'components/primitives/Menu';
import Footer, {
  IFooterCompany,
  IFooterContact,
  IFooterPrivacyPolicies,
} from 'components/static/Footer';
import Map from 'components/static/Map';

import 'i18n/config';

import { ISuluPage } from 'types/interfaces/sulu/IPages';

import suluErrorHandler from 'utils/sulu/errorHandler';

import { COMPANY_NAME } from '../constants';

const HeadlessTemplatePage = ({ data }: { data: ISuluPage }) => {
  const { t } = useTranslation();

  /**
   * Init Klaro only once
   * */
  useEffect(() => {
    // we assign the Klaro module to the window, so that we can access it in JS
    // @ts-ignore
    window.klaro = Klaro;
    // @ts-ignore
    window.klaroConfig = klaroConfig;
    // @ts-ignore
    Klaro.setup(klaroConfig);
    // we set up Klaro with the config
    const klaroCookie = window.document.cookie.match(
      // eslint-disable-next-line prefer-regex-literals
      new RegExp('(^| )klaroStorage=([^;]+)'),
    );
    // if klaroCookie is set, take no further action
    if (!klaroCookie) {
      // @ts-ignore
      Klaro.show();
    }
  }, []);

  /**
   * Track page change if tracking is enabled
   * */
  useEffect(() => {
    // update document title after page change
    document.title = `COR3 | Fehler`;
    // scroll to top
    const scrollToOptions = { top: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle,no-multi-assign,@typescript-eslint/naming-convention
    const _paq = (window._paq = window._paq || []);
    // @ts-ignore
    if (window.enableTracking) {
      // eslint-disable-next-line no-restricted-globals
      _paq.push(['setCustomUrl', location.pathname]);
      _paq.push(['setDocumentTitle', document.title]);
      _paq.push(['trackPageView']);
    }
  }, []);

  const footerCompany: IFooterCompany = {
    name: COMPANY_NAME,
    locations: [
      {
        name: '',
        address: 'Rudolf-Diesel-Str. 40-46<br/>68169 Mannheim<br/>Deutschland',
      },
    ],
  };

  const footerContact: IFooterContact = {
    title: t('general.contact'),
    address: {
      name: 'Martin Daumann',
      email: 'info@compliance-co.com',
      phone: '+49 621 150 217 00',
    },
  };

  const footerPrivacyPolicies: IFooterPrivacyPolicies = {
    title: t('components.footer.privacyPolicies'),
    links: [
      {
        name: t('components.footer.imprint'),
        url: t('components.footer.imprintLink'),
      },
      {
        name: t('components.footer.dataPrivacy'),
        url: t('components.footer.dataPrivacyLink'),
      },
    ],
  };

  return (
    <ParallaxProvider>
      <div className='max-w-none'>
        <Menu />
        {suluErrorHandler(data)}
        <Map id='map' latLng={[49.5228474, 8.4655344]} />
        <div id='mapImage' className='relative'>
          <img
            src='/assets/map/map-image.jpg'
            className='w-full'
            alt={t('altTexts.map')}
          />
        </div>
        <Footer
          company={footerCompany}
          contact={footerContact}
          privacyPolicies={footerPrivacyPolicies}
        />
      </div>
    </ParallaxProvider>
  );
};

// <pre className='overflow-hidden'>{JSON.stringify(data, null, 2)}</pre>

export default HeadlessTemplatePage;
